import React, { useEffect, useRef } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Stethoscope } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash || '';
    const sid = new URLSearchParams(hash.replace('#', '')).get('session_id');
    (async () => {
      if (!sid) { navigate('/login'); return; }
      try {
        const res = await axios.post(`${API}/auth/session`, {}, { headers: { 'X-Session-ID': sid }, withCredentials: true });
        setUser(res.data);
        window.history.replaceState(null, '', '/dashboard');
        navigate('/dashboard', { state: { user: res.data } });
      } catch (e) {
        navigate('/login');
      }
    })();
  }, []);

  return (
    <div className="min-h-screen grid place-items-center hero-gradient">
      <div className="text-center">
        <span className="grid place-items-center w-16 h-16 rounded-2xl text-white mx-auto mb-5 animate-pulse" style={{ background: 'linear-gradient(135deg,#0f766e,#0b3b3a)' }}>
          <Stethoscope size={30} />
        </span>
        <p className="text-teal-800 font-medium">Signing you in…</p>
      </div>
    </div>
  );
}
